import { featureFlagLogic } from "./feature-logic";
import { handleFeatureFlagError } from "./error-handling";

export async function featureFlagAsync({
  alternateBehavior,
  defaultEnabled,
  enabled,
  enabledBehavior,
  flagName,
  hasLoaded,
}) {
  if (!hasLoaded) {
    return undefined;
  }

  const isEnabled = enabled || (enabled === undefined && defaultEnabled);

  try {
    const result = await featureFlagLogic({
      alternateBehavior,
      enabledBehavior,
      isEnabled,
    });

    return result;
  } catch (error) {
    handleFeatureFlagError(error, flagName, isEnabled);
  }
}

export function featureFlag({
  alternateBehavior,
  defaultEnabled,
  enabled,
  enabledBehavior,
  flagName,
  hasLoaded,
}) {
  if (!hasLoaded) {
    return undefined;
  }

  const isEnabled = enabled || (enabled === undefined && defaultEnabled);

  try {
    const result = featureFlagLogic({
      alternateBehavior,
      enabledBehavior,
      isEnabled,
    });

    return result;
  } catch (error) {
    handleFeatureFlagError(error, flagName, isEnabled);
  }
}
